import React from "react";
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { AgingIncomingInvoiceMoreActionProps } from "models/propTypes/incomingInvoicePropTypes";
import { AuthEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import useIncomingInvoiceDownload from "./useDownload";
import { MoreActions } from "components/common";
import useAgingIncomingInvoiceSnoozeAction from "./actions/useAgingIncomingInvoiceSnoozeAction";
//#endregion
import { CompanyService } from "services";
import { LocalizationHelperInstance } from "utils/helpers";

const AgingIncomingInvoiceMoreActions: React.FC<AgingIncomingInvoiceMoreActionProps> = (props) => {
  const { agingInvoice, markAsDoneHandler } = props;

  const snoozeAction = useAgingIncomingInvoiceSnoozeAction(agingInvoice.id, markAsDoneHandler);

  //#region download
  const onDownloadClick = useIncomingInvoiceDownload(agingInvoice.incomingInvoiceId);

  const downloadAction: MoreActionMenuItemType = {
    description: `${LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Common.Download
    )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Invoice)}`,
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: onDownloadClick,
  };
  //#endregion

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    !CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor) && actions.push(snoozeAction);
    actions.push(downloadAction);
    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={props.disableSuccessMessages} />;
};

export default AgingIncomingInvoiceMoreActions;
